import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectsTitle: {
		id: 'horizontal-nav-header.breadcrumbs.project',
		defaultMessage: 'Projects',
		description: 'Title of the breadcrumb that navigates to the projects directory',
	},
	projectsTitleGalaxia: {
		id: 'horizontal-nav-header.breadcrumbs.project-galaxia',
		defaultMessage: 'Spaces',
		description: 'Title of the breadcrumb that navigates to the projects directory',
	},
});
